<template>
    <NavbarMain/>

    <PresentationSection v-if="currentLanguage === 'translated'" :photo="first_section_image_translated" :title="first_section_title_translated" :content="first_section_content_translated"/>
    <PresentationSection v-else :photo="first_section_image_en" :title="first_section_title_en" :content="first_section_content_en"/>

    <CardSection v-if="currentLanguage === 'translated'" :content-title="second_section_title_translated" :content-sentance="second_section_content_translated" :button-text="second_section_link_content_translated" :button-link="second_section_link_translated"/>
    <CardSection v-else :content-title="second_section_title_en" :content-sentance="second_section_content_en" :button-text="second_section_link_content_en" :button-link="second_section_link_en"/>

    <ContentWithPhoto v-if="currentLanguage === 'translated'" :content-photo_image="third_section_image_translated" :content-photo_title="third_section_title_translated" :content-photo_content1="third_section_content_translated"/>
    <ContentWithPhoto v-else :content-photo_image="third_section_image_en" :content-photo_title="third_section_title_en" :content-photo_content1="third_section_content_en"/>

    <WidePhotoComponent v-if="currentLanguage === 'translated'" :photo="fourth_section_image_translated" :content="fourth_section_content_translated" />
    <WidePhotoComponent v-else :photo="fourth_section_image_en" :content="fourth_section_content_en" />

    <FooterPage/>    
</template>
 
<script>
import axios from 'axios';
import CardSection from '@/components/CardSection.vue';
import ContentWithPhoto from '@/components/ContentWithPhoto.vue';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import PresentationSection from '@/components/PresentationSection.vue';
import WidePhotoComponent from '@/components/WidePhotoComponent.vue';
 
export default {
    components: {
    NavbarMain,
    PresentationSection,
    FooterPage,
    ContentWithPhoto,
    WidePhotoComponent,
    CardSection
},
    data() {
        return {
            stgData: {
                items_translated: [{first_section_title: '', first_section_content: '', first_section_image: '',second_section_title: '', second_section_content: '', second_section_link: '', second_section_link_content: '', third_section_image: '', third_section_title: '', third_section_content: '', fourth_section_image: '', fourth_section_content: ''}],
                items_en: [{first_section_title: '', first_section_content: '', first_section_image: '',second_section_title: '', second_section_content: '', third_section_image: '', third_section_title: '', third_section_content: '', fourth_section_image: '', fourth_section_content: ''}]
            },
            first_section_title_translated: '',
            first_section_content_translated: '',
            first_section_image_translated: '',
            second_section_title_translated: '',
            second_section_content_translated: '',
            second_section_link_translated: '',
            second_section_link_content_translated: '',
            third_section_image_translated: '',
            third_section_title_translated: '',
            third_section_content_translated: '',
            fourth_section_image_translated: '',
            fourth_section_content_translated: '',
        
            first_section_title_en: '',
            first_section_content_en: '',
            first_section_image_en: '',
            second_section_title_en: '',
            second_section_content_en: '',
            second_section_link_en: '',
            second_section_link_content_en: '',
            third_section_image_en: '',
            third_section_title_en: '',
            third_section_content_en: '',
            fourth_section_image_en: '',
            fourth_section_content_en: '',
        }
    },
    computed: {
        currentLanguage() {
            return this.$store.getters.getCurrentLanguage;
        },
    },
    created() {
        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;
 
        axios.get(`${API_URL}/api/stg-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.stgData = response.data || { items_translated: [], items_en: [] };
                console.log(this.stgData)
            
                if (this.stgData.items_translated[0].active === true) {
                    this.first_section_title_translated = this.stgData.items_translated[0].first_section_title;
                    this.first_section_content_translated = this.stgData.items_translated[0].first_section_content;
                    this.first_section_image_translated = API_URL + this.stgData.items_translated[0].first_section_image;
                    this.second_section_title_translated = this.stgData.items_translated[0].second_section_title;
                    this.second_section_content_translated = this.stgData.items_translated[0].second_section_content;
                    this.second_section_link_translated = this.stgData.items_translated[0].second_section_link;
                    this.second_section_link_content_translated = this.stgData.items_translated[0].second_section_link_content;
                    this.third_section_image_translated = API_URL + this.stgData.items_translated[0].third_section_image;
                    this.third_section_title_translated = this.stgData.items_translated[0].third_section_title;
                    this.third_section_content_translated = this.stgData.items_translated[0].third_section_content;
                    this.fourth_section_image_translated = API_URL + this.stgData.items_translated[0].forth_section_image;
                    this.fourth_section_content_translated = this.stgData.items_translated[0].forth_section_content;
                }
                if (this.stgData.items_en[0].active === true) {
                    this.first_section_title_en = this.stgData.items_en[0].first_section_title;
                    this.first_section_content_en = this.stgData.items_en[0].first_section_content;
                    this.first_section_image_en = API_URL + this.stgData.items_en[0].first_section_image;
                    this.second_section_title_en = this.stgData.items_en[0].second_section_title;
                    this.second_section_content_en = this.stgData.items_en[0].second_section_content;
                    this.second_section_link_en = this.stgData.items_en[0].second_section_link;
                    this.second_section_link_content_en = this.stgData.items_en[0].second_section_link_content;
                    this.third_section_image_en = API_URL + this.stgData.items_en[0].third_section_image;
                    this.third_section_title_en = this.stgData.items_en[0].third_section_title;
                    this.third_section_content_en = this.stgData.items_en[0].third_section_content;
                    this.fourth_section_image_en = API_URL + this.stgData.items_en[0].forth_section_image;
                    this.fourth_section_content_en = this.stgData.items_en[0].forth_section_content;
                }
                console.log(this.first_section_image_en)
            })
            .catch(error => {
                console.error('Error fetching About US data:', error);
            });


        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    }
}
 
</script>
 
<style>
 
</style>
